<template>
	<div class="b-counter" :class="{'b-counter_disabled': disabled}">
		<a href="javascript:void(0);" class="icon icon--minus b-counter__icon b-counter__icon_minus" @click.prevent="decrease"></a>
		<div class="b-counter__inputWrap">
			<input class="b-counter__input" type="hidden" v-model="currentQuantity" :step="measure.ratio"
			       :min="measure.ratio" :max="maxQuantity"
			       @input="update"
			>
			<span class="b-counter__value" v-html="currentQuantity"></span>
		</div>
		<a href="javascript:void(0);" class="icon icon--plus b-counter__icon b-counter__icon_plus" @click.prevent="increase"></a>
	</div>
</template>
<script>
	export default {
		name: "Quantity",
		props: {
			id: {
				type: [Number, String],
				default: ""
			},
			quantity: {
				type: Number,
				default: 1
			},
			measure: {
				type: Object,
				default: function () {
					return {
						name: "",
						ratio: 1,
					}
				}
			},
			maxQuantity: {
				type: Number,
				default: 9999
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data: function () {
			return {
				currentQuantity: this.quantity
			};
		},
		watch: {
			quantity: function () {
				this.currentQuantity = this.quantity;
			}
		},
		methods: {
			decrease: function () {
				this.update(true, false);
			},
			increase: function () {
				this.update(false, true);
			},
			update: function (checkDecrease, checkIncrease) {
				checkDecrease = !!checkDecrease;
				checkIncrease = !!checkIncrease;

				this.checkStepValue();
				if (checkDecrease) {
					this.checkMinValue();
				}
				if (checkIncrease) {
					this.checkMaxValue();
				}

				this.sendChanged();
			},
			checkMinValue: function () {
				if (this.currentQuantity > this.measure.ratio) {
					this.currentQuantity -= this.measure.ratio;
				}
			},
			checkMaxValue: function () {
				if ((this.currentQuantity + this.measure.ratio) <= this.maxQuantity) {
					this.currentQuantity += this.measure.ratio;
				}
			},
			checkStepValue: function () {
				if (this.currentQuantity % this.measure.ratio !== 0) {
					this.currentQuantity = Math.floor(this.currentQuantity / this.measure.ratio);
				}
			},
			sendChanged: function () {
				this.$emit("change", {id: this.id, quantity: parseFloat(this.currentQuantity)});
			}
		}
	}
</script>